<template>
  <v-container>
    <v-row class="contentRow">
      <v-col>
        <h1 class="mb-4">Most Recent Blocks</h1>
        <v-data-table
          :loading="loading"
          theme--
          light
          :headers="headers"
          :items="blocks"
          item-key="hash"
          :items-per-page="20"
          hide-default-footer
          class="light blocktable"
        >
          <template v-slot:item.index="{ item }">
            <v-chip :to="'/blocks/'+item.index" color="primary" label>
              {{item.index}}
              <v-icon right small>fas fa-external-link-alt</v-icon>
            </v-chip>
          </template>
          <template v-slot:item.hash="{ item }">
            <span class="text-wrap">{{item.hash}}</span>
          </template>
        </v-data-table>
      </v-col>
      <error-dialog :error="error" />
    </v-row>
  </v-container>
</template>


<script>
import API from "../api/api"

export default {
  name: "Blocks",

  data() {
    return {
      headers: [
        {
          text: "Block Index",
          align: "start",
          sortable: false,
          value: "index"
        },
        { text: "Timestamp", value: "timestamp", sortable: false },
        { text: "Hash", value: "hash", sortable: false },
        { text: "Size", value: "size", sortable: false }
      ],
      blocks: [],
      error: null,
      loading: false,
      interval: null
    };
  },
  mounted() {
    //Dummy data
    /*this.blocks = [
      {index: "10",timestamp: "19582342392",size: "69kB",hash: "hashhashhashhashhashhashhash"},
      {index: "9",timestamp: "19582342392",size: "639kB",hash: "asdfasdfasdfasdfdf"},
      {index: "8",timestamp: "19582342392",size: "69kB",hash: "hashhashhashhashhashhashhash"},
      {index: "7",timestamp: "19582342392",size: "69kB",hash: "hashhashhashhashhashhashhash"},
      {index: "6",timestamp: "19582342392",size: "69kB",hash: "hashhashhashhashhashhashhash"},
      {index: "5",timestamp: "19582342392",size: "69kB",hash: "hashhashhashhashhashhashhash"},
      {index: "4",timestamp: "19582342392",size: "639kB",hash: "asdfasdfasdfasdfdf"},
      {index: "3",timestamp: "19582342392",size: "69kB",hash: "hashhashhashhashhashhashhash"},
      {index: "2",timestamp: "19582342392",size: "69kB",hash: "hashhashhashhashhashhashhash"},
      {index: "1",timestamp: "19582342392",size: "69kB",hash: "hashhashhashhashhashhashhash"},
    ]*/
    this.loadItems()
    this.interval = setInterval(()=>this.loadItems(), 5000)
  },
  methods: {
    loadItems() {
      this.loading = true;
      API
        .get("/api/blocks/?order=desc")
        .then(response => {
          this.loading = false;
          
          // Check for errors in response
          if (response.data.error && Array.isArray(response.data.error) && response.data.error.length > 0) {
            this.error = response.data.error[0].message;
            return;
          }
          
          // Check if data exists and is an array
          if (!response.data.data) {
            this.blocks = [];
            return;
          }
          
          if (!Array.isArray(response.data.data)) {
            console.error("Data is not an array:", typeof response.data.data);
            this.error = "Invalid response format from server";
            this.blocks = [];
            return;
          }
          
          const newBlocks = [];
          for (let entry of response.data.data) {
            if (entry && entry.Index !== undefined) {
              newBlocks.push({
                index: entry.Index,
                timestamp: this.$moment.unix(entry.Timestamp).fromNow(),
                size: entry.Size,
                hash: entry.Hash
              });
            }
          }
          // If backend temporarily returns fewer blocks than we already have (e.g. during sync),
          // keep the current list so the UI does not flicker between 7 and 11 rows.
          if (newBlocks.length < this.blocks.length) {
            return;
          }
          // Keep order stable: newest first (desc by index)
          newBlocks.sort((a, b) => (b.index - a.index));
          this.blocks = newBlocks;
        })
        .catch(reason => {
          const errData = reason.response?.data
          const msg = (Array.isArray(errData?.error) && errData.error[0]?.message)
            || errData?.error
            || errData?.message
            || reason.message
            || String(reason)
          this.error = msg || "A software error has occurred. Please contact support if the error persists."
          this.loading = false
        })
    }
  }
};
</script>
<style>
.blocktable tbody tr:nth-of-type(odd) {
  background-color: #3d264533;
}
</style>